
import React from 'react';
import { Button } from "@/components/ui/button";
import { InfoIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const LinkHelpInfo: React.FC = () => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0 ml-2" title="Help">
          <InfoIcon className="h-4 w-4" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-4">
        <div className="space-y-2">
          <h4 className="font-medium">Get the best Google Maps link</h4>
          <p className="text-sm text-muted-foreground">
            For best results, follow these steps in Google Maps:
          </p>
          <ol className="text-sm pl-4 space-y-1">
            <li>Search for the terrace location</li>
            <li>Click on the location to open its details</li>
            <li>Click the "Share" button</li>
            <li>Select "Copy link" and paste it here</li>
          </ol>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default LinkHelpInfo;
